import IconLibraryBooks from '@material-ui/icons/LibraryBooks'

export const qlpMenuItems = [

    {
        name: 'QLP',
        // path: '/qlp',
        Icon: IconLibraryBooks,
        items: [
            {

                name: 'Add new QLP',
                path: '/qlp/add',
                id: 'new-qlp',

                description: 'Add new Qlp File'
            },
            {
                name: 'QLP Metric - Docs',
                path: '/display/documentation/qlp_metrics/',
                id: 'QLP Metrics Documentation',
            }

            // {
            //     name: 'Unprocessed Files',
            //     path: '/qlp/list/unprocessed',
            //     id: 'qlp-list-unprocessed',

            //     description: 'List of Unprocessed Qlps'
            // },
            // {
            //     name: 'Processed Files',
            //     path: '/qlp/list/processed',
            //     id: 'qlp-list-processed',

            //     description: 'List of processed Qlps'
            // },
            // {
            //     name: 'Search',
            //     path: '/qlp/search',
            //     id: 'qlp-search',
            //     description: 'Search Qlp'
            // }

        ]
    }

];

export const ddPcrMenuItems = [

    {
        name: 'ddPCR',
        // path: '/qlp',
        Icon: IconLibraryBooks,
        items: [
            {

                name: 'Add new ddPCR',
                path: '/ddpcr/add',
                id: 'new-ddPcr',

                description: 'Add new ddPcr File'
            },

            {
                name: 'Unprocessed Files',
                path: '/ddpcr/list/unprocessed',
                id: 'ddPcr-list-unprocesed',

                description: 'List of Unprocessed ddPcr'
            },

            {
                name: 'Processed Files',
                path: '/ddpcr/list/processed',
                id: 'ddPcr-list',

                description: 'List of Processed ddPcr'
            }
        ]
    }
];

export const QCMenuItems = [

    {
        name: 'QC',
        Icon: IconLibraryBooks,
        items: [
            {
                name: 'Upload QC',
                path: '/qlpqc/add',
                id: 'Upload QLP',
            },

            {
                name: 'Create Batch',
                path: '/qc/Create_Batch',
                id: 'Create Batch',
            },

            {
                name: 'QC Plates List',
                path: '/list_plates/qc',
                id: 'QC Plate List',
            },

            {
                name: 'QLP Files List',
                path: '/qlp/list_files',
                id: 'QLP File List',
            }



        ]


    }

];

export const mfgMenuItems = [

    {
        name: 'MFG',
        Icon: IconLibraryBooks,
        items: [
            {
                name: 'Send Report',
                path: '/ddpcr/mfg',
                id: 'send-mfg-report',
            },

            {
                name: 'View Report',
                path: '/ddpcr/mfg/view-report',
                id: 'view-mfg-report',
            },
            {
                name: 'Add Serial #',
                path: '/ddpcr/mfg/addSerialNum',
                id: 'add-serial-num',
            },
            {
                name: 'MFG Plates List',

                path: '/list_plates/mfg',
                id: 'MFG Plate List',
            },



        ]


    }
];

export const autoDgMenuItems = [
    {
        name: 'AutoDG',
        Icon: IconLibraryBooks,
        items: [
            {
                name: 'AutoDG Plates List',
                path: '/ddpcr/autoDG/list_plates',
                id: 'AutoDG Plate List',
            },
        ]

    }

]


